import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Header({ cartItemCount }) {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <header className="header">
      <h1>{t('shop_title')}</h1>
      <p>{t('header_subtitle')}</p>
      <nav>
        <Link to="/">{t('home')}</Link>
        <Link to="/cart" className="cart-icon">
          {t('cart')} ({cartItemCount})
        </Link>
        <button onClick={() => changeLanguage('en')}>EN</button>
        <button onClick={() => changeLanguage('it')}>IT</button>
      </nav>
    </header>
  );
}

export default Header;
